import { Button } from 'react-bootstrap';
import '../../assets/styles/PlaceOrderScreen.css';

const StickyOrderSummary = ({ cart, actionLabel, onAction, discountLabel = 'Descuento' }) => {
    const totalPrice = Number(cart?.totalPrice || 0);
    const discountAmount = Number(cart?.discountAmount || 0);

    return (
        <div className="checkout-mobile-bar sticky-summary d-md-none">
            <div className="checkout-mobile-bar-summary">
                <div>
                    <span className="checkout-mobile-bar-label">Total a pagar</span>
                    <strong className="checkout-mobile-bar-amount">${totalPrice.toFixed(2)}</strong>
                </div>
                <div className="checkout-mobile-bar-meta">
                    <span>IVA incluido</span>
                    {discountAmount > 0 && (
                        <span className="text-success fw-semibold">
                            {discountLabel} -${discountAmount.toFixed(2)}
                        </span>
                    )}
                </div>
            </div>
            {actionLabel ? (
                <Button type="button" className="checkout-mobile-bar-action" onClick={onAction}>
                    {actionLabel}
                </Button>
            ) : null}
        </div>
    );
};

export default StickyOrderSummary;
